export default __webpack_public_path__ + "static/media/Icons_Arrows_Caret_Left_Bold.c98c9e64.svg";